import React from 'react';

function NavigationBar(props) {
  return (
    <div className='navigation-bar'>
      <div className='navigation-bar__logo'>
        <img className='navigation-bar__logo--icon' src='icon-inverted-128x128.png' alt='iHomework 2' />
        <h1 className='navigation-bar__logo--title'>iHomework 2</h1>
        <div className='navigation-bar__logo--version'>
          Alpha
        </div>
      </div>

      <div className='navigation-bar__links'>
        <a href='http://www.ihomeworkapp.com/app/index.html'>iOS</a>
        <a href='http://www.ihomeworkapp.com/app/macOS.html'>Mac</a>
        <a href='http://blog.ihomeworkapp.com/'>Blog</a>
        <a href='http://www.ihomeworkapp.com/app/support.html'>Support</a>
      </div>
    </div>
  );
}

export default NavigationBar;


// WEBPACK FOOTER //
// ./src/scenes/Authentication/components/NavigationBar.js